import * as React from 'react';
import type { SVGProps } from 'react';

const SvgAntDesignPlusOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={24} fill="none" {...props}>
    <path
      fill="#D04237"
      d="M11.519 3.563h-1.254c-.112 0-.168.062-.168.187v16.5c0 .125.056.188.168.188h1.254c.111 0 .167-.063.167-.188V3.75c0-.125-.056-.188-.167-.188Z"
    />
    <path
      fill="#D04237"
      d="M17.916 11.11H3.868c-.111 0-.167.062-.167.187v1.406c0 .125.056.188.167.188h14.048c.111 0 .167-.063.167-.188v-1.406c0-.125-.056-.188-.167-.188Z"
    />
  </svg>
);
export default SvgAntDesignPlusOutlined;
